import { PipelineStatus } from '@optools/services/operator-gateway/types/generated/graphql';

export const isEVIDisabled = (status: PipelineStatus) =>
  [PipelineStatus.ARCHIVED, PipelineStatus.ENDING, PipelineStatus.ENDED].includes(status);
